import $ from "jquery";

class FadeInScroll {
    constructor() {
        this.$fadedWrapper = $('.js-fade-wrapper');
        this.$fadedObject = $('.js-fade');

        if (this.$fadedObject.length) {
            if (
                "IntersectionObserver" in window &&
                "IntersectionObserverEntry" in window &&
                "intersectionRatio" in window.IntersectionObserverEntry.prototype
            ) {
                this.observeStats();
            } else {
                this.$fadedObject.addClass('is-visible');
            }
        }
    }

    observeStats() {
        // Fire when the block is 50% visible
        const config = {
            threshold: 0.5
        };

        let observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // When intersecting, add class
                    $(entry.target).addClass('is-visible')

                    // Only fire this once
                    observer.unobserve(entry.target);
                }
            });
        }, config);

        this.$fadedObject.each((index, element) => {
            observer.observe(element);
        });
    }
}

export default FadeInScroll;
